import React from "react";

import { InputAdornment, TextField, TextFieldProps, Typography } from "@mui/material";

interface TutredTextAreaProps extends Omit<TextFieldProps, 'color'> {
    placeholder?: string;
    rows?: number;
    variant?: "outlined" | "filled" | "standard";
    color?: "secondary" | "primary";
    maxLength?: number;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const TutredTextArea: React.FC<TutredTextAreaProps> = ({
    placeholder = "",
    rows = 4,
    variant = "outlined",
    color = "secondary",
    maxLength = 300,
    value = "",
    onChange,
    ...props
}) => {
    const [internalValue, setInternalValue] = React.useState("");
    const displayValue = value !== undefined ? value : internalValue;
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (maxLength && e.target.value.length > maxLength) return;
        if (onChange) onChange(e);
        if (value === undefined) setInternalValue(e.target.value);
    };

    return (
        <TextField
            color={color}
            {...props}
            placeholder={placeholder}
            multiline
            rows={rows}
            sx={{
                '& .MuiInputBase-input': {
                    maxHeight: 'unset !important',
                    marginBottom: '24px !important',
                },
                ...props.sx
            }}
            inputProps={{
                maxLength,
                ...props.inputProps
            }}
            variant={variant}
            value={displayValue}
            onChange={handleChange}
            error={props.error}
            helperText={props.helperText}
            slotProps={{
                input: {
                    sx: {
                        alignItems: 'flex-start',
                    },
                    endAdornment: (
                        <InputAdornment
                            position="end"
                            sx={{
                                position: "absolute",
                                bottom: '8px',
                                right: '14px',
                                height: 'auto',
                                maxHeight: 'none',
                                pointerEvents: 'none',
                            }}
                        >
                            <Typography variant="text12M" color="text.secondary">
                                {`${displayValue.length}/${maxLength}`}
                            </Typography>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};